function runPreloader() {
    const preloader = document.querySelector("#touro-preloader");

    if (!preloader) return;

    document.body.classList.add("preloading");

    const tl = gsap.timeline({
        defaults: {
            ease: "power3.out"
        },
        onComplete: () => {
            preloader.remove();
            document.body.classList.remove("preloading");
            runHeroAnimation();
        }
    });

    tl.from(".preloader-logo", {
        opacity: 0,
        y: 20,
        filter: "blur(6px)",
        duration: 0.8
    })

    .to(".preloader-logo", {
        scale: 0.88,
        duration: 0.4
    })

    .to(".pre-img", {
        opacity: 1,
        scale: 1,
        filter: "blur(0px)",
        stagger: 0.15,
        duration: 0.6
    }, "-=0.15")

    .to("#touro-preloader", {
        yPercent: -100,
        duration: 0.9,
        ease: "power4.inOut"
    });
}

function runHeroAnimation() {

    const heading = document.querySelector(".hero__heading");
    const subheading = document.querySelector(".hero__subheading");

    if (!heading) return;

    const tl = gsap.timeline();

    tl.from(heading, {
        opacity: 0,
        y: 30,
        filter: "blur(4px)",
        duration: 0.9,
        ease: "power3.out"
    })

    .from(subheading, {
        opacity: 0,
        y: 20,
        duration: 0.7,
        ease: "power2.out"
    }, "-=0.6");

}

window.addEventListener("load", () => {

    // If we've already shown the loader once, remove it
    if (sessionStorage.getItem("touroLoaded")) {
        document.querySelector("#touro-preloader")?.remove();
        runHeroAnimation();
        return;
    }

    // First visit
    sessionStorage.setItem("touroLoaded", "true");
    runPreloader();

});